export default "__VITE_ASSET__BMNsfqM4__"